import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { css } from "styled-components";

export const standardLabelStyles = css<{
  required?: boolean;
  hasValue?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
}>`
  position: absolute;
  left: 16px;
  top: 8px;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-size: ${FontSize.Small};
  color: ${(props) => (props.disabled ? Color.DarkGrey : Color.Black)};
  font-weight: 400;
  transition: all 0.2s ease;
  pointer-events: none;
  background: transparent;
  z-index: 1;

  ${(props) =>
    props.required &&
    `
    &::after {
      content: '*';
      color: ${props.disabled ? Color.DarkGrey : Color.Black};
      margin-left: 2px;
    }
  `}
`;

export const standardInputStyles = css<{
  fontSize?: FontSize;
  hasError?: boolean;
  hasValue?: boolean;
  isOpen?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
}>`
  border: 1px solid transparent;
  border-radius: 6px;
  width: 100%;
  padding: 24px 40px 8px 16px;
  background: ${(props) => (props.disabled ? Color.LightGrey02 : "#f8f9fa")};
  font-size: ${(props) => props.fontSize || FontSize.Standard};
  color: ${(props) => (props.disabled ? Color.DarkGrey : Color.InputTextColor)};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 400;
  transition: all 0.2s ease;
  outline: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  position: relative;
  display: flex;
  align-items: center;
  min-height: 48px;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? Color.LightGrey02 : "#f1f3f4")};
  }

  ${(props) =>
    (props.isOpen || props.isFocused) &&
    !props.disabled &&
    `
    background: ${Color.White};
    border-color: #e5e7eb;
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
  `}
`;
